module.exports = __webpack_public_path__ + "img/mall_03.2ee1c206.png";